import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./styles/global.scss";
import VueI18n from "vue-i18n";
import zh from "./locales/zh";
import en from "./locales/en";

Vue.use(ElementUI);
Vue.use(VueI18n);
Vue.config.productionTip = false;

const savedLang = localStorage.getItem("lang") || "zh";

const i18n = new VueI18n({
  locale: savedLang,
  messages: { zh, en },
});

new Vue({
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app");
